// extracted by mini-css-extract-plugin
export var aboutUsLeft = "about-us-module--aboutUsLeft--j9x+F";
export var aboutUsParent = "about-us-module--aboutUsParent--qp4zp";
export var aboutUsRight = "about-us-module--aboutUsRight--UbaQl";